"use client";

import { env } from "@repo/design-system/setup/env";
import { useParams } from "next/navigation";
import z from "zod";

/** Valid `[client]` segments across apps that use this hook (tkag/uniper/amso + eon subclients). */
const clientSchema = z.enum(["tkag", "tkagi", "tkms", "tkmsi", "uniper", "uniperi", "amso", "eon", "econ", "eon-gridsolutions", "controlsolutions", "edg-sub", "westnetz", "e-dis", "edialog-netz", "avacon", "avaconwasser", "bayernwerk", "e-wie-einfach", "westenergie", "rww", "hansewerk", "suewag", "sverige", "edri", "hungary", "uk"]);

/**
 * Retrieves the current client from the Next.js dynamic route parameters. This param get’s validated.
 * If the param is not valid, returns env.CLIENT as defaultValue
 * @returns valid client
 */
export function useClient() {
  const params = useParams();
  const result = clientSchema.safeParse(params.client).success;
  if (result) {
    return params.client as string;
  }
  return env.CLIENT;
}